export default __webpack_public_path__ + "ad140171b46cee8f609ff220d7835bc7.png";